import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LoginButton from './LoginButton';
import { canAccessAdmin } from '../utils/permissions';
import './TopNavBar.css';

function TopNavBar({
  onAdminLinkClick,
  loggedInUser = '',
  permissions = [],
  userRole = '',
  ownedClubId = null,
  onLogout,
  onLoginSuccess,
  loginModalOpen = false,
  loginModalMode = 'login',
  onLoginModalOpenChange,
}) {
  const location = useLocation();

  const handleAdminLinkClick = (e) => {
    if (location.pathname === '/admin') {
      e.preventDefault();
      onAdminLinkClick?.();
    }
  };

  return (
    <div className="top-nav">
      <div className="nav-links">
        <Link to="/" className="nav-link">Home</Link>
        <a href="/cards/handtest.html" className="nav-link">Hand Test</a>
        {canAccessAdmin(permissions, userRole) ? (
          <Link to="/admin" className="nav-link" onClick={handleAdminLinkClick}>
            Admin Panel
          </Link>
        ) : ownedClubId ? (
          <Link to="/club-manage" className="nav-link">
            Manage Club
          </Link>
        ) : null}
      </div>
      <div className="user-info">
        {loggedInUser && (
          <div className="user-account">
            <span className="username">Welcome, {loggedInUser}</span>
            <Link
              to="/settings"
              className="user-settings-link"
              title="Account settings"
              aria-label="Account settings"
            >
              <span className="user-settings-icon" aria-hidden="true">&#9881;</span>
            </Link>
          </div>
        )}
        <LoginButton
          loggedInUser={loggedInUser}
          onLogout={onLogout}
          onLoginSuccess={onLoginSuccess}
          externalOpen={loginModalOpen}
          externalMode={loginModalMode}
          onExternalOpenChange={onLoginModalOpenChange}
        />
      </div>
    </div>
  );
}

export default TopNavBar;